import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import LeadManagement from './components/LeadManagement';
//import AddLead from './pages/AddLead';
import './App.css';

const App = () => {
    return (
        <Router>
            <Layout>
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/manage-leads" element={<LeadManagement />} />
                    <Route path="/leads" element={<LeadManagement />} />
                    {/* Add more routes here as you create more pages */}
                </Routes>
            </Layout>
        </Router>
    );
};

export default App;